import React, { useState, useEffect } from "react";
import { Link } from 'react-router-dom';
import apiHelper from '../../apiHelper';

export default () => {
  const [departmentsCount, setDepartmentsCount] = useState(0);
  const [workplacesCount, setWorkplacesCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [activeCount, setActiveCount] = useState(0);
  const [suspendedCount, setSuspendedCount] = useState(0);
  const [offboardedCount, setOffboardedCount] = useState(0);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);

        // Fetch departments count
        const departmentsResponse = await apiHelper('departments/list/?status=True', 'GET');
        const departments = await departmentsResponse.json()
        console.log("departmentsResponse", departments); // Log full response for debugging
        const departmentsData = departments || [];
        setDepartmentsCount(Array.isArray(departmentsData) ? departmentsData.length : 0);

        // Fetch workplaces count
        const workplacesResponse = await apiHelper('entities/workplaces/?status=True', 'GET');
        const workplaces = await workplacesResponse.json()
        console.log("workplacesResponse", workplaces); // Log full response for debugging
        const workplacesData = workplaces || [];
        setWorkplacesCount(Array.isArray(workplacesData) ? workplacesData.length : 0);

        // Fetch Employees
        const employeesResponse = await apiHelper('users/list/', 'GET');
        const employees = await employeesResponse.json();

        // Calculate counts
        let active = 0;
        let suspended = 0;
        let offboarded = 0;

        const today = new Date();

        employees.forEach(emp => {
          if (emp.offboard_date && new Date(emp.offboard_date) < today) {
            offboarded++;
          } else if (emp.status === true) {
            active++;
          } else if (emp.status === false) {
            suspended++;
          }
        });

        setActiveCount(active);
        setSuspendedCount(suspended);
        setOffboardedCount(offboarded);

        setLoading(false);
      } catch (err) {
        console.error("API fetch error:", err); // Log error for debugging
        setError('Failed to fetch data');
        setLoading(false);
      }
    };

    fetchData();
  }, []); // Empty dependency array ensures this runs only on mount

  return (
    <>
      <div className="dashboard-overview">
        <h2 className="dashboard-title">Dashboard</h2>
        <div className="dashboard-cards">
          <Link to="/dashboardoverview" className="dashboard-card employee-card">
            <strong>Employees</strong>
            <div className="employee-content">
              <div className="employee-stats">
                <div className="employee-row">
                  <span className="dot dot-active"></span> Active
                  <span className="employee-count">{activeCount}</span>
                </div>
                <div className="employee-row">
                  <span className="dot dot-suspended"></span> Suspended
                  <span className="employee-count">{suspendedCount}</span>
                </div>
                <div className="employee-row">
                  <span className="dot dot-offboarded"></span> Off boarded
                  <span className="employee-count">{offboardedCount}</span>
                </div>
              </div>
              <div className="employee-chart">
                <div className="donut">
                  <span className="donut-center">{activeCount + suspendedCount + offboardedCount}</span>
                </div>
              </div>
            </div>
          </Link>
          <Link to="/dashboardoverview" className="dashboard-card">
            <strong>Departments</strong>
            {loading ? (
              <h3 className="dashboard-card-count">Loading...</h3>
            ) : error ? (
              <h3 className="dashboard-card-count">Error</h3>
            ) : (
              <h3 className="dashboard-card-count">{departmentsCount}</h3>
            )}
          </Link>
          <Link to="/dashboardoverview" className="dashboard-card">
            <strong>Workplaces</strong>
            {loading ? (
              <h3 className="dashboard-card-count">Loading...</h3>
            ) : error ? (
              <h3 className="dashboard-card-count">Error</h3>
            ) : (
              <h3 className="dashboard-card-count">{workplacesCount}</h3>
            )}
          </Link>
        </div>
      </div>
    </>
  );
};